import OrganizationArrivalRatesPerService from "../../../components/organization/reports/daily/OrganizationArrivalRatesPerService";
import DailyGeneratedReportPage from "../../../components/reports/DailyGeneratedReportPage";
import { REPORT_TYPE_IDS } from "../../../store/constants";
import { ARRIVAL_RATES_PER_SERVICE_COLUMN_DEFINITIONS } from "../../../store/renderConfig";

const DailyOrganizationArrivalRatesPerService = ({ showFilterForm = true, showTitle = 1 }) => (
  <DailyGeneratedReportPage
    reportTypeId={REPORT_TYPE_IDS.daily_organization_arrival_rates_per_service}
    title="Arrival Rates Per Service"
    helmetTitle="Daily Organization Arrival Rates Per Service"
    descriptionKey="ArrivalRatesByService"
    columnDefinitions={ARRIVAL_RATES_PER_SERVICE_COLUMN_DEFINITIONS}
    defaultSortColumn="total"
    showFilterForm={showFilterForm}
    showTitle={showTitle}
  >
    {({ data, renderConfig, onRenderConfigChange }) => (
      <OrganizationArrivalRatesPerService
        data={data}
        renderConfig={renderConfig}
        onRenderConfigChange={onRenderConfigChange}
      />
    )}
  </DailyGeneratedReportPage>
);

export default DailyOrganizationArrivalRatesPerService;
